var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isMultiValueSubfield } from './ProposalForm/utils/multiValueSubfield';
var PICKER_INPUT_TYPES = new Set(['vocabulary', 'record-picker', 'multi-vocabulary', 'multi-record-picker']);
export var subfieldSource = function (sf) {
    var _a;
    // Neither is typed by the cataloguer, whatever control draws it: a derived value follows
    // its source subfield (`DerivedComponentSubfield`) — the more specific fact, so it goes
    // first — and a read-only one is not edited in the form at all.
    if (sf.derivedFrom) {
        return { kind: 'derived', tag: sf.derivedFrom.tag, subfield: sf.derivedFrom.subfield };
    }
    if (sf.readOnly === true) {
        return { kind: 'readOnly' };
    }
    if (sf.staticOptions === true || (sf.selectOptions && sf.selectOptions.length > 0)) {
        return { kind: 'staticList' };
    }
    var type = sf.recordType || sf.vocabularyType || '';
    var picker = PICKER_INPUT_TYPES.has((_a = sf.inputType) !== null && _a !== void 0 ? _a : '') || (isMultiValueSubfield(sf) && type !== '');
    if (!picker || type === '') {
        return { kind: 'text' };
    }
    var allowFreeText = sf.allowFreeText === true;
    return type.startsWith('VOCABULARY_')
        ? { kind: 'vocabulary', type: type, allowFreeText: allowFreeText }
        : { kind: 'authority', type: type, allowFreeText: allowFreeText };
};
/**
 * The properties `tag $code` is bound to. Usually one; a subfield bound differently per
 * indicator yields each property once, with the indicator values it is limited to — a
 * property bound both with and without a condition applies always. Qualifier binds refine
 * another property's value and carry no stewardship of their own, so they are not listed.
 */
export var subfieldProperties = function (catalog, tag, code) {
    var _a, _b, _c, _d;
    var entry = (_a = catalog.marc21Fields) === null || _a === void 0 ? void 0 : _a[tag];
    // null = bound unconditionally at least once, which outranks every condition.
    var conditions = new Map();
    for (var _i = 0, _e = (_b = entry === null || entry === void 0 ? void 0 : entry.binds) !== null && _b !== void 0 ? _b : []; _i < _e.length; _i++) {
        var bind = _e[_i];
        var bound = bind.subfield === code || ((_c = bind.subfields) !== null && _c !== void 0 ? _c : []).includes(code);
        if (bound) {
            var when = bind.whenIndicator && Object.keys(bind.whenIndicator).length > 0 ? bind.whenIndicator : null;
            var known = conditions.has(bind.property) ? (_d = conditions.get(bind.property)) !== null && _d !== void 0 ? _d : null : [];
            conditions.set(bind.property, known === null || when === null ? null : __spreadArray(__spreadArray([], known, true), [when], false));
        }
    }
    return Array.from(conditions.entries()).flatMap(function (_a) {
        var _b, _c;
        var name = _a[0], whenIndicator = _a[1];
        var property = (_b = catalog.properties) === null || _b === void 0 ? void 0 : _b[name];
        return property
            ? [{
                    name: name,
                    label: property.label,
                    stewardship: property.stewardship,
                    alignments: (_c = property.alignments) !== null && _c !== void 0 ? _c : {},
                    whenIndicator: whenIndicator !== null && whenIndicator !== void 0 ? whenIndicator : [],
                }]
            : [];
    });
};
/** `repeatable_default` of the ontology subfield; undefined when the catalog does not say. */
export var subfieldRepeatable = function (catalog, tag, code) {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = catalog.marc21Fields) === null || _a === void 0 ? void 0 : _a[tag]) === null || _b === void 0 ? void 0 : _b.subfields) === null || _c === void 0 ? void 0 : _c.find(function (s) { return s.code === code; })) === null || _d === void 0 ? void 0 : _d.repeatable_default;
};
/**
 * RDA element registry URL of an alignment such as `rdau:P60625`, or null when the
 * alignment is not an RDA element. The prefixes are the RDA Registry's own
 * (`rdaa`, `rdac`, … `rdau`, `rdaw`, `rdax`), each a directory under `Elements/`.
 */
export var rdaElementUrl = function (alignment) {
    var match = /^rda([a-z]):(P\d+)$/.exec(alignment.trim());
    return match ? "http://rdaregistry.info/Elements/".concat(match[1], "/").concat(match[2]) : null;
};
